import template from './index.html'
import controller from './controller'

PartOrderDetail.vsName = 'partOrderDetail'
PartOrderDetail.vsNgType = 'directive'

PartOrderDetail.$inject = []
function PartOrderDetail() {
  return {
    restrict: 'E',
    controller: controller,
    controllerAs: 'ctrl',
    bindToController: true,
    templateUrl: template,
    scope: {
      partOrder: '='
    }
  }
}

export default PartOrderDetail